import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { usePermissions } from "@/context/PermissionsContext";
import { SearchableSelect } from "@/components/common/SearchableSelect";
import { ClientScope3Panel } from "@/components/sustainability/ClientScope3Panel";
import { Building2 } from "lucide-react";

export function ClientScope3Tab({ fy }) {
  const { role } = usePermissions();
  const isClient = (role || "").toLowerCase() === "client";
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");

  useEffect(() => {
    if (isClient) return;
    api.get("/sustainability/scope3-clients")
      .then((r) => {
        const list = r.data.items || (r.data.clients || []).map((n) => ({ name: n }));
        setClients(list);
        if (list.length && !client) setClient(list[0].name);
      })
      .catch(() => {});
    // eslint-disable-next-line
  }, [isClient]);

  return (
    <div className="space-y-4">
      {!isClient && (
        <div className="flex items-center gap-2">
          <Building2 className="w-4 h-4 text-slate-400" />
          <SearchableSelect
            value={client}
            onChange={setClient}
            options={clients.map((c) => ({
              value: c.name, label: c.name,
              meta: c.invoiced_ex != null ? `$${Math.round(c.invoiced_ex / 1000).toLocaleString()}k` : undefined,
            }))}
            placeholder="Search client…"
            width="w-[340px]"
            testid="scope3-client-select"
          />
          <span className="text-xs text-slate-400">Top invoiced clients first — type to search</span>
        </div>
      )}
      {(isClient || client) ? (
        <ClientScope3Panel clientName={isClient ? undefined : client} fy={fy} />
      ) : (
        <div className="rounded-lg border border-slate-200 bg-white p-6 text-sm text-slate-500">Select a client to view their Scope 3 attribution.</div>
      )}
    </div>
  );
}
